export function isNotNullOrUndefined<T>(value: T): value is Exclude<NonNullable<T>, void> {
    return typeof value !== 'undefined' && value !== null;
}
